

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormItem, Option, Select } from 'element-ui';

import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// gql
import fetchOperatorsQuery from '@/graphql/queries/FetchOperators.gql';

// types
import {
  OperatorFields,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    operators: {
      query: fetchOperatorsQuery,
      fetchPolicy: 'cache-and-network',
      update(data) {
        return data.operators;
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 2000
        });
      }
    }
  },
  components: {
    UtcDatePicker,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': Select
  }
})
export default class Header extends Vue {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  operators: OperatorFields[] = [];

  get assignedOperator() {
    return this.value.assignedOperator;
  }

  set assignedOperator(data) {
    this.$emit('input', { ...this.value, assignedOperator: data });
  }

  get issuanceDate() {
    return this.value.issuanceDate;
  }

  set issuanceDate(data) {
    this.$emit('input', { ...this.value, issuanceDate: data });
  }
}
